import { Service } from '@roc/feature-app-core';

const url = {
  SUBMIT_STATE_LICENSE: '/api/v1/taskV2/loanTaskV2/submitStateLicense',
  STATE_LICENSE_ORIGINATOR: '/api/v1/taskV2/loanTaskV2/stateLicenseOriginator',
  STATE_LICENSE_DATA: '/api/v1/taskV2/loanTaskV2/stateLicenseData',
};

export class StateLicenseTaskService extends Service {
  getStateLicenseOriginator(taskId: number) {
    return this.get(url.STATE_LICENSE_ORIGINATOR, { taskId });
  }

  getStateLicenseData(lenderId: number, type: string, state: string, originatorId?: number) {
    const params: Record<string, any> = { lenderId, type, state };
    if (type === 'ORIGINATOR' && originatorId) params.originatorId = originatorId;
    return this.get(url.STATE_LICENSE_DATA, params);
  }

  submitStateLicense(taskId: number, expirationDate: string, file: File) {
    const formData = new FormData();
    formData.append('taskId', String(taskId));
    formData.append('expirationDate', expirationDate);
    formData.append('file', file);
    return this.post(url.SUBMIT_STATE_LICENSE, formData);
  }
}
